module.exports = __webpack_public_path__ + "static/media/beerpong.c20a10d8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/beerpong.mp4
// module id = 144
// module chunks = 0